<template>
    <div class="container-fluid mt-3">
      <v-card flat>

      <v-layout row wrap>
        <v-flex hidden-sm-and-down md5>
          <div style="text-align:center">
            <img src="/img/ethereum.svg" width="25" alt="ethereum"><h1 class="ml-4" style="display:inline-block">ETHEREUM-CFA (XOF)</h1>
          </div>
        </v-flex>

        <v-flex xs12 md7>
          <v-layout row wrap >
          <v-flex xs6 md5 justify-center layout>
            <v-chip color="#6492D4" text-color="white">
              <v-avatar class="green darken-4">ETH</v-avatar>
              <span class="bal" v-cloak>{{user.ethBalance? new Intl.NumberFormat("fr-FR",{maximumFractionDigits:5}).format(user.ethBalance) : 0}}</span>
            </v-chip>
          </v-flex>
          <v-flex xs6 md5 justify-center layout>
            <v-chip color text-color="white">
              <v-avatar class="green darken-4">CFA</v-avatar>
              <span class="bal">{{user.cfaBalance ? new Intl.NumberFormat("fr-FR", {maximumFractionDigits:0}).format(user.cfaBalance) : 0}}</span>
            </v-chip>
          </v-flex>
        </v-layout>
        </v-flex>
      </v-layout>

      </v-card>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      hm: false
    }
  },
mounted () {
    this.hm=true
},
computed: mapState("authfb", ["user"]),
methods: mapActions("authfb", ["init"])

}
</script>

<style scoped>
[v-cloak] { display: none !important; }

.bal {
  font-size: 1.5em;
  color: black;

}

</style>
